import {Type} from 'class-transformer';

import {Message} from '../messages/message';

/**
 * Group dynamic data, <br>
 * Not Stored in DB, created dynamically for current user
 *
 * @category Group Entity
 * */
export class GroupDynamicData {

  /**
   * Last message of this group
   * */
  @Type(() => Message)
  lastMessage: Message = null;

  /**
   * First unread message of current user
   * */
  firstUnreadMessageId: string = null;

  /**
   * Number of unread messages
   * */
  unreadMessagesCount = 0;

  /**
   * Number of unread mentions<br>
   * Not implemented yet
   * */
  unreadMentionsCount = 0;

  /**
   * Number of unread reactions<br>
   * Not implemented yet
   * */
  unreadReactionsCount = 0;
}
